import React from 'react';
import { 
  FaUsers, 
  FaBuilding, 
  FaBed, 
  FaClipboardList, 
  FaTools, 
  FaRupeeSign, 
  FaBell,
  FaUserTie, 
  FaChartBar, 
  FaCloud, 
  FaMobileAlt, 
  FaShieldAlt, 
  FaHeadset, 
  FaCheck 
} from 'react-icons/fa';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <FaUsers />,
      title: 'Paying Guest Management',
      description: 'Complete PG lifecycle management from registration to checkout with detailed profiles, documentation, and resident history tracking.',
      features: [
        'Guest Registration & Profiles',
        'Document Management',
        'Stay History Tracking',
        'Check-in/Check-out Management',
        'Guest Communication'
      ]
    },
    {
      icon: <FaBuilding />,
      title: 'Building Management',
      description: 'Comprehensive building administration with room layouts, facility management, and real-time availability tracking.',
      features: [
        'Property Management',
        'Room Layout Management',
        'Facility Tracking',
        'Availability Management',
        'Building Maintenance'
      ]
    },
    {
      icon: <FaBed />,
      title: 'Bed Management & Maintenance',
      description: 'Smart bed inventory system with condition tracking, maintenance scheduling, and availability optimization.',
      features: [
        'Bed Inventory Management',
        'Condition Tracking',
        'Maintenance Scheduling',
        'Availability Optimization',
        'Bed Pricing Management'
      ]
    },
    {
      icon: <FaClipboardList />,
      title: 'Allocation Management',
      description: 'Efficient bed allocation system with automated assignment, transfer capabilities, and occupancy optimization.',
      features: [
        'Automated Bed Assignment',
        'Transfer Management',
        'Occupancy Optimization',
        'Allocation History',
        'Waitlist Management'
      ]
    },
    {
      icon: <FaTools />,
      title: 'Complaint Management',
      description: 'Streamlined complaint handling system with ticket tracking, priority management, and resolution workflow.',
      features: [
        'Ticket System',
        'Priority Management',
        'Resolution Workflow',
        'Staff Assignment',
        'Complaint Analytics'
      ]
    },
    {
      icon: <FaRupeeSign />,
      title: 'Invoicing & Payments',
      description: 'Monthly invoice generation and payment collection system with automated billing and payment tracking.',
      features: [
        'Automated Billing',
        'Invoice Generation',
        'Payment Processing',
        'Payment Tracking',
        'Financial Reports'
      ]
    },
    {
      icon: <FaBell />,
      title: 'Payment Reminders',
      description: 'Automated WhatsApp notification system for payment reminders and allocation updates to keep everyone informed.',
      features: [
        'WhatsApp Payment Reminders',
        'Due Date Notifications',
        'Allocation Start Alerts',
        'Allocation End Reminders',
        'Custom Message Templates'
      ]
    },
    {
      icon: <FaUserTie />,
      title: 'Staff Management',
      description: 'Complete staff administration with role management, task assignment, and performance tracking.',
      features: [
        'Employee Profiles',
        'Role Management',
        'Task Assignment',
        'Performance Tracking',
        'Staff Scheduling'
      ]
    },
    {
      icon: <FaChartBar />,
      title: 'Reports & Analytics',
      description: 'Comprehensive dashboards and reports providing insights into occupancy, revenue, and operational metrics.',
      features: [
        'Occupancy Reports',
        'Revenue Analytics',
        'Operational Metrics',
        'Custom Reports',
        'Data Export'
      ]
    }
  ];

  return (
    <div className="services-page">
      <div className="page-header">
        <div className="header-container">
          <h1>Our Services</h1>
          <div className="pricing-note">
            <p>Our platform charges from ₹10,000 and ends up to ₹20,000</p>
          </div>
        </div>
      </div>

      <div className="services-container">
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <FaCheck />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Technology Section */}
        <div className="tech-section">
          <h2>Technology & Security</h2>
          <p>Built with modern technology stack for reliability and security</p>
          
                    <div className="tech-grid">
            <div className="tech-card">
              <FaCloud />
              <h4>Cloud-Based</h4>
              <p>Access your data anytime, anywhere with our secure cloud infrastructure.</p>
            </div>
            <div className="tech-card">
              <FaMobileAlt />
              <h4>Mobile Responsive</h4>
              <p>Fully optimized for mobile devices ensuring seamless experience.</p>
            </div>
            <div className="tech-card">
              <FaShieldAlt />
              <h4>Secure</h4>
              <p>Enterprise-grade security with encrypted data storage.</p>
            </div>
            <div className="tech-card">
              <FaHeadset />
              <h4>24/7 Support</h4>
              <p>Dedicated support team available to help you anytime.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
